import { render, staticRenderFns } from "./ImageTopBarIcon.vue?vue&type=template&id=501664ff&"
import script from "./ImageTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./ImageTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports